/** Only this backend marker means the account itself is disabled. */
export function isAccountDisabledError(error) {
  return Number(error?.code) === 403 && error?.data?.reason === 'ACCOUNT_DISABLED';
}

export function accountDisabledErrorFromResponse(body) {
  if (!isAccountDisabledError(body)) return null;
  const error = new Error(String(body.msg || body.message || '').trim());
  error.code = 403;
  error.data = body.data;
  return error;
}

export function isSameAuthRequestSession(expected, current) {
  return Boolean(
    expected?.owned &&
      expected.token &&
      expected.token === current.token &&
      expected.generation === current.generation
  );
}

/** Holds feedback outside the routed page so sign-out navigation cannot discard it. */
export function createAccountDisabledSessionHandler({ getSession, invalidateSession }) {
  let notice = null;
  const listeners = new Set();
  const publish = () => listeners.forEach((listener) => listener(notice));

  return {
    handle(error, session) {
      if (!isAccountDisabledError(error) || !session?.owned) return false;
      // Concurrent and stale errors must not create a second, page-local notification.
      error.authFeedbackHandled = true;
      if (!isSameAuthRequestSession(session, getSession())) return true;
      invalidateSession();
      notice = { message: error.message };
      publish();
      return true;
    },
    subscribe(listener) {
      listeners.add(listener);
      listener(notice);
      return () => listeners.delete(listener);
    },
    dismiss() {
      notice = null;
      publish();
    },
  };
}
